module.exports = __webpack_public_path__ + "static/img/13.9f57d39.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/sp/13.png
// module id = dzoz
// module chunks = 0